import { z } from 'zod';

import { emailSchema, passwordSchema } from '@web/utils';

export const loginSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
  remember_me: z.boolean().default(true),
  invite_code: z.string().optional(),
});

export type LoginSchema = z.infer<typeof loginSchema>;
